export default __webpack_public_path__ + "static/media/05.3d890192.jpg";